import FabianJacob from "../images/clientes/webps/fabijacob.webp"
import Tonutti from '../images/clientes/webps/lacteostonutti.webp'
import DonSolano from '../images/clientes/webps/donsolano.webp'
import Dulcidan from '../images/clientes/webps/dulcidan.webp'
import EsperanzaBlanca from '../images/clientes/webps/lacteosesperanzablanca.webp'
import Fabri from '../images/clientes/webps/fabri.webp'
import Feller from '../images/clientes/webps/feller.webp'
import Fritz from '../images/clientes/webps/fritz.webp'
import Herrlain from '../images/clientes/webps/herrlain.webp'
import Horizonte from '../images/clientes/webps/horizonte.webp'
import LaPiara from '../images/clientes/webps/lapiara.webp'
import MLuisa from '../images/clientes/webps/marialuisa.webp'
import Gunda from '../images/clientes/webps/gunda.webp'
import SIsabel from '../images/clientes/webps/santaisabel.webp'
import Santana from '../images/clientes/webps/santana.webp'
import OroVerde from '../images/clientes/webps/oroverde.webp'
import LAR from '../images/clientes/webps/lar.webp'

export const clientesData = [
    {
        "id": 0,
        "nombre": "Feller",
        "src": Feller, 
        "link": "https://feller.com.ar/"
    },
    {
        "id": 1,
        "nombre": "Lacteos Tonutti",
        "src": Tonutti, 
        "link": "https://lacteostonutti.com.ar/"
    },
    {
        "id": 11,
        "nombre": "Frigorifico Santa Isabel",
        "src": SIsabel, 
        "link": "https://maps.app.goo.gl/fweBrUg2vrymLqfE8"
    },
    {
        "id": 3,
        "nombre": "Lacteos Esperanza Blanca",
        "src": EsperanzaBlanca, 
        "link": "https://esperanzablanca.com.ar/"
    },
    {
        "id": 8,
        "nombre": "Horizonte Distribuciones",
        "src": Horizonte, 
        "link": "https://www.facebook.com/horizonte.distribucionessrl"
    },
    {
        "id": 2,
        "nombre": "DonSolano",
        "src": DonSolano, 
        "link": "https://lacteosdonsolano.com/"
    },
    {
        "id": 4,
        "nombre": "Dulcidan",
        "src": Dulcidan, 
        "link": "https://dulcidan.com.ar/"
    },
    {
        "id": 5,
        "nombre": "Fabri Helados",
        "src": Fabri, 
        "link": "https://www.instagram.com/fabriheladeria/"
    },
    {
        "id": 6,
        "nombre": "Fritz",
        "src": Fritz, 
        "link": ""
    },
    {
        "id": 9,
        "nombre": "La Piara",
        "src": LaPiara, 
        "link": "https://www.lapiara.com/es/"
    },
    {
        "id": 7,
        "nombre": "Herrlain",
        "src": Herrlain, 
        "link": "https://www.herrlein.com.ar/"
    },
    {
        "id": 10,
        "nombre": "Gunda Heladeria",
        "src": Gunda, 
        "link": "https://www.instagram.com/gunda.heladeria/"
    },
    {
        "id": 15,
        "nombre": "La Agricola Regional",
        "src": LAR, 
        "link": "https://www.laronline.com.ar/"
    },
    {
        "id": 12,
        "nombre": "Fabian Jacob Distribuciones",
        "src": FabianJacob, 
        "link": "https://www.facebook.com/fjdistri/"
    },
    {
        "id": 13,
        "nombre": "Lacteos Estancia María Luisa",
        "src": MLuisa, 
        "link": "https://estanciamarialuisa.com.ar/"
    },
    {
        "id": 14,
        "nombre": "Municipio de Oro Verde",
        "src": OroVerde, 
        "link": "https://oroverde.gob.ar/portal/"
    }
]
